module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card card-indent mt-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row bg-primary-light"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "text-weight-normal mb-2"
  }, [_vm._v(_vm._s(_vm.isExpired ? _vm.labels.HEADING_EXPIRED : _vm.labels.HEADING))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p'), (_vm.formSubmitted && (!_vm.formValid)) ? _c('div', {
    staticClass: "feedback",
    attrs: {
      "id": "feedbackPanel"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(!_vm.loginFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.LOGIN_FIELD_REQUIRED) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.loginValid) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.CHANGE_DENIED_TEXT) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.isEmail) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.LOGIN_FAIL) + "\n                    ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: " alert alert-success alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.SUCCESS_TEXT) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.forbidden) ? _c('div', {
    staticClass: " alert alert-danger alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.PASSWORD_RESET_TOO_OFTEN) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.failed) ? _c('div', {
    staticClass: " alert alert-danger alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.RESET_FAILED) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isExpired && !_vm.success) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.labels.LINK_EXPIRED) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.success) ? _c('form', {
    attrs: {
      "id": "id1",
      "method": "post",
      "name": "CredentialsForm",
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "j_username"
    }
  }, [_vm._v(_vm._s(_vm.labels.USER))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.UserName),
      expression: "credentials.UserName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login",
      "type": "text",
      "value": "",
      "name": "user",
      "maxlength": "300"
    },
    domProps: {
      "value": (_vm.credentials.UserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.UserName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group button-start"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "saveButton"
    },
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v(_vm._s(_vm.isExpired ? _vm.labels.SAVE_EXPIRED : _vm.labels.SAVE))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "cancelButton"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.labels.CANCEL))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_c('a', {
    attrs: {
      "href": "mailto:web.helpdesk@mm.group"
    }
  }, [_vm._v(_vm._s(_vm.labels.HELP))])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-gray-light my-4"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-72 mmk-icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "position": "absolute",
      "left": "-100px",
      "top": "-100px",
      "overflow": "hidden"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id1_hf_0",
      "id": "id1_hf_0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c741600","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword/ForgotPassword.vue
// module id = 182
// module chunks = 1